export const CANONICAL_HEX_SIZE = 50;
